export default {
	'main.openHistoryAndTodoDrawer': 'Open history and todo drawer',
	'main.closeHistoryAndTodoDrawer': 'Close history and todo drawer',
};
